export class SignalrNotification {
  constructor(
    public connectionId: string,
    public userId: string,
    public callbackMethodName: string
  ) { }
}
